$(() => {
  const analysis_term = () => {
    parseInt($('#financing-term').val());
  }

  const number_of_contracts = () => {
    return parseInt($('#no-of-contracts').val().replaceAll(',', ''), 10);
  };

  const number_of_employees = () => {
    return parseInt($('#number-of-employees').val().replaceAll(',', ''), 10);
  };

  const compliance_base = () => {
    if (number_of_employees() < 101) {
      return 21500;
    } else if (number_of_employees() < 201) {
      return 26700;
    } else if (number_of_employees() < 601) {
      return 26700;
    } else if (number_of_employees() < 1001) {
      return 33400;
    } else if (number_of_employees() < 1501) {
      return 49000;
    } else if (number_of_employees() < 2501) {
      return 57000;
    } else if (number_of_employees() < 4001) {
      return 70000;
    } else if (number_of_employees() < 10001) {
      return 78800;
    } else if (number_of_employees() < 25001) {
      return 95000;
    } else if (number_of_employees() < 40001) {
      return 128750;
    } else if (number_of_employees() < 55001) {
      return 160550;
    } else if (number_of_employees() < 70001) {
      return 183050;
    } else if (number_of_employees() < 85001) {
      return 198150;
    } else if (number_of_employees() < 105001) {
      return 207150;
    } else if (number_of_employees() < 135001) {
      return 212350;
    }

    return 218350;
  };

  const per_addl_employee = () => {
    if (number_of_employees() < 201) {
      return 0;
    } else if (number_of_employees() < 601) {
      return 1675;
    } else if (number_of_employees() < 1001) {
      return 39;
    } else if (number_of_employees() < 1501) {
      return 16;
    } else if (number_of_employees() < 2501) {
      return 13;
    } else if (number_of_employees() < 4001) {
      return 5.85;
    } else if (number_of_employees() < 10001) {
      return 2.7;
    } else if (number_of_employees() < 25001) {
      return 2.25;
    } else if (number_of_employees() < 40001) {
      return 2.12;
    } else if (number_of_employees() < 55001) {
      return 1.5;
    } else if (number_of_employees() < 70001) {
      return 1;
    } else if (number_of_employees() < 85001) {
      return 0.6;
    } else if (number_of_employees() < 105001) {
      return 0.26;
    } else if (number_of_employees() < 135001) {
      return 0.2;
    }

    return 0.16;
  };

  const employees_base_for_tier = () => {
    if (number_of_employees() < 100) {
      return 0;
    } else if (number_of_employees() < 200) {
      return 101;
    } else if (number_of_employees() < 600) {
      return 201;
    } else if (number_of_employees() < 1000) {
      return 601;
    } else if (number_of_employees() < 1500) {
      return 1001;
    } else if (number_of_employees() < 2500) {
      return 1501;
    } else if (number_of_employees() < 4000) {
      return 2501;
    } else if (number_of_employees() < 10000) {
      return 4001;
    } else if (number_of_employees() < 25000) {
      return 10001;
    } else if (number_of_employees() < 40000) {
      return 25001;
    } else if (number_of_employees() < 55000) {
      return 40001;
    } else if (number_of_employees() < 70000) {
      return 55001;
    } else if (number_of_employees() < 85000) {
      return 70001;
    } else if (number_of_employees() < 105000) {
      return 85001;
    } else if (number_of_employees() < 135000) {
      return 105001;
    }

    return 135001;
  };

  const tier_max = () => {
    if (number_of_employees() < 100) {
      return 21500;
    } else if (number_of_employees() < 200) {
      return 26700;
    } else if (number_of_employees() < 600) {
      return 33383;
    } else if (number_of_employees() < 1000) {
      return 48961;
    } else if (number_of_employees() < 1500) {
      return 56984;
    } else if (number_of_employees() < 2500) {
      return 69987;
    } else if (number_of_employees() < 4000) {
      return 78769;
    } else if (number_of_employees() < 10000) {
      return 94997;
    } else if (number_of_employees() < 25000) {
      return 128748;
    } else if (number_of_employees() < 40000) {
      return 160548;
    } else if (number_of_employees() < 55000) {
      return 183049;
    } else if (number_of_employees() < 70000) {
      return 198049;
    } else if (number_of_employees() < 85000) {
      return 207149;
    } else if (number_of_employees() < 105000) {
      return 212350;
    } else if (number_of_employees() < 135000) {
      return 218350;
    }
  }

  const extra_employees = () => {
    return number_of_employees() - employees_base_for_tier();
  };

  const per_employee_total = () => {
    return extra_employees() * per_addl_employee();
  };

  const compliance_total_price = () => {
    // =O31+S31
    // COMPLIANCE_BASE + PER_EMPLOYEE_TOTAL
    return compliance_base() + per_employee_total();
  };

  const compliance_license_fee = () => {
    // const net_patient_revenue = parseInt($('#net-patient-revenue').val().replaceAll(',', ''), 10);
    // =IF(T31>Q31,Q31,T31)
    // IF TOTAL_PRICE > TIER_MAX THEN TIER_MAX, ELSE TOTAL_PRICE
    if (compliance_total_price() > tier_max()) {
      return tier_max();
    }

    return compliance_total_price();
  };

  const contract_license_fee = () => {
    // =IF(N18=TRUE,(Q37+R37)*12,0)
    // (MODULE_PRICE + PRICE_USED)*12
    return (contract_module_price() + contract_price_used()) * 12;
  };

  const contract_module_price = () => {
    if (number_of_contracts() < 501) {
      return 2000;
    } else if (number_of_contracts() < 2001) {
      return 3900;
    } else if (number_of_contracts() < 5001) {
      return 8000;
    } else if (number_of_contracts() < 10001) {
      return 14250;
    }

    return 19250;
  };

  const contract_price_used = () => {
    if (number_of_contracts() < 101) {
      if (analysis_term() < 3) {
        return 2128;
      } else if (analysis_term() < 5) {
        return 1900;
      } else {
        return 1672;
      }
    } else if (number_of_contracts() < 501) {
      if (analysis_term() < 3) {
        return 3186;
      } else if (analysis_term() < 5) {
        return 2845;
      } else {
        return 2504;
      }
    } else if (number_of_contracts() < 2001) {
      if (analysis_term() < 3) {
        return 6494;
      } else if (analysis_term() < 5) {
        return 5798;
      } else {
        return 5103;
      }
    } else if (number_of_contracts() < 5001) {
      if (analysis_term() < 3) {
        return 14772;
      } else if (analysis_term() < 5) {
        return 13189;
      } else {
        return 11607;
      }
    } else if (number_of_contracts() < 1001) {
      if (analysis_term() < 3) {
        return 24384;
      } else if (analysis_term() < 5) {
        return 21771;
      } else {
        return 19159;
      }
    } else {
      if (analysis_term() < 3) {
        return 32701;
      } else if (analysis_term() < 5) {
        return 29197;
      } else {
        return 25694;
      }
    }
  }

  const run = () => {
    if ($('#compliance-license-fee-overridden').val() === '0') {
      $('#compliance-license-fee').val(accounting.formatMoney(compliance_license_fee(), '', 0));
    }

    if ($('#contract-license-fee-overridden').val() === '0') {
      $('#contract-license-fee').val(accounting.formatMoney(contract_license_fee(), '', 0));
    }
  };

  $('#number-of-employees, #analysis-term, #no-of-contracts').blur(() => {
    run();
  });

  $('#contract-license-fee').blur(() => {
    $('#contract-license-fee-overridden').val('1');
  });

  $('#compliance-license-fee').blur(() => {
    $('#compliance-license-fee-overridden').val('1');
  });
});
